import * as React from 'react'
function SvgArrowDown(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M32 21.2a1.98 1.98 0 00-2.8 0L22 28.4V6a2 2 0 10-4 0v22.4l-7.2-7.2A1.98 1.98 0 008 24l10.586 10.586a2 2 0 002.828 0L32 24a1.98 1.98 0 000-2.8z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgArrowDown
